import { IPaginatedResponseObject } from 'app/services';
import Label from 'Components/Form/Label';
import SelectDropDown from 'Components/SelectDropDown';
import BasePagination from '../BasePagination';
import { PaginationMeta } from '../PaginationMeta';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import { SelectInput } from 'Components/Auth/SelectInput';

export default function ServerPagination({
  pagination,
  onPageChange,
  onper_pageChange,
}: {
  onPageChange: (pageNumber: number) => void;
  onper_pageChange: (pageNumber: number) => void;
  pagination: IPaginatedResponseObject;
}) {
  // if (pagination.count === 0) return <></>;

  const from =
    pagination.count > 0
      ? pagination.page * pagination.per_page - pagination.per_page + 1
      : 0;

  const to =
    pagination.count > pagination.page * pagination.per_page
      ? pagination.page * pagination.per_page
      : pagination.count;

  const total = pagination.count;
  return (
    <div className="text-sm border-t-2 p-4 border-gray-800 pt-3 text-gray-dark flex justify-between items-center">
      <div className="whitespace-nowrap flex flex-wrap items-center gap-2 text-gray-700">
        <Label label="Per Page" className="hidden md:block" />
        <SelectDropDown
          onChange={(x) => x && onper_pageChange(x)}
          options={[3, 4, 5, 10, 15, 20, 25].map((x) => ({
            id: x,
            label: String(x),
          }))}
          value={pagination.per_page}
          searchable={false}
          clearable={false}
        />
        <PaginationMeta from={from} to={to} total={total} />
      </div>

      <BasePagination
        per_page={pagination.per_page}
        totalCount={pagination.pages}
        onPageChange={onPageChange}
        currentPage={pagination.page}
      />
    </div>
  );
}
